module.exports = __webpack_public_path__ + "img/calendar-outlined.fca2d0b1.svg";